<template>
  <component :stroke="stroke" v-if="icon" :is="icon" class="icon"></component>
</template>
<script setup>
import { defineAsyncComponent, h, computed } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "",
  },
  stroke: {
    type: String,
    default: "",
  },
  fill: {
    type: String,
    default: "",
  },
});
const icons = {
  IconArrowTop: "arrow-top",
  IconArrowRight: "arrow-right",
  IconArrowSecondLeft: "arrow-second-left",
  IconArrowSecondRight: "arrow-second-right",
  IconArrowThirdLeft: "arrow-third-left",
  IconArrowThirdRight: "arrow-third-right",
  IconClose: "close",
  IconLocation: "location",
};

const components = import.meta.glob("@/components/Base/Icon/list/*.vue");
const icon = computed(() => {
  const iconPath =
    props.name && icons[props.name]
      ? `/components/Base/Icon/list/${icons[props.name]}.vue`
      : null;

  return iconPath && components[iconPath]
    ? defineAsyncComponent({
        loader: components[iconPath],
        loadingComponent: {
          render() {
            return h("div", { class: "svg" });
          },
        },
        delay: 0,
      })
    : null;
});
</script>
<style lang="scss" scoped>
.icon:not(.fill) :deep(path) {
  transition: $transition;
  stroke: $black;
}
.icon.fill :deep(path) {
  transition: $transition;
  fill: $black;
}
.icon.white:not(.fill) :deep(path) {
  transition: $transition;
  stroke: $white;
}
.icon.white.fill :deep(path) {
  transition: $transition;
  fill: $white;
}
</style>
